import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title = 'Poliklinika Akrion - Fizioterapija, Ortopedija, Kineziterapija Labin',
  description = 'Stručna fizioterapija, ortopedija i kineziterapija u Labinu. Moderna dijagnostika i tretmani za vaše zdravlje.',
  keywords = 'poliklinika, fizioterapija, ortopedija, kineziterapija, ultrazvuk, Labin, Akrion, rehabilitacija',
  canonical = 'https://poliklinika-akrion.hr/',
  ogImage = '/og-image.jpg',
  structuredData = null
}) => {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={canonical} />
      
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={ogImage} />
      
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
      
      {structuredData && (
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      )}
    </Helmet>
  );
};

export default SEO;